import React, { useState } from 'react';

export default function Faq() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <style>
        {`
        
.pq-section.pq-style-1.text-center {
  text-align: center;
  margin-bottom: 20px;
}

.pq-section-sub-title {
  font-size: 18px;
  color: #666;
  display: block;
  margin-bottom: 10px;
}

.pq-section-title {
  font-size: 28px;
  color: #333;
  font-weight: 600;
}


.pq-accordion-block {
  width: 100%;
}

.pq-accordion-box {
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 10px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.pq-accordion-box.active {
  border-color: #239857;
}

.pq-ad-title {
  padding: 15px;
  background-color: #f9f9f9;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ad-title-text {
  font-size: 16px;
  color: #333;
  margin: 0;
  flex: 1;
}

.pq-accordion-details {
  padding: 0 15px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
}

.pq-accordion-details.open {
  padding: 15px;
  max-height: 500px; 
}

.pq-detail-text {
  font-size: 14px;
  color: #555;
  line-height: 1.6;
  margin: 0;
}

.fa {
  font-size: 14px;
  color: #239857;
  transition: transform 0.3s ease;
}

.fa-chevron-down {
  transform: rotate(0deg);
}

.fa-chevron-up {
  transform: rotate(180deg);
}
.pq-accordion-block .pq-accordion-box .pq-accordion-details {
  padding: 0 20px  !important;
  border: 1px solid var(--grey-color);
  border-top: 0;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}
`}
      </style>
      <section className="faq">
        <div className="container py-4">
          <div className="row">
           <div className="col-md-7">
            <div className="pq-section pq-style-1 text-center">
               <h2 className="pq-section-title">Frequently Asked Questions (FAQ’s)</h2>
            </div>
            
            <div className="col-xl-12 mt-xl-0 ps-xl-3">
              <div className="pq-accordion-block mt-4">
                {[ 
                  { question: "What conditions does a speech therapy clinic treat?", answer: "A speech therapy clinic treats speech delay, stammering, unclear speech, articulation issues, voice disorders, language delay, autism-related communication problems, and adult speech difficulties. Therapy helps improve clarity, fluency, and communication skills for all age groups." },
                  { question: "How does a speech therapy session work?", answer: "The therapist first evaluates speech and language skills, then creates a personalised plan. Sessions include speech exercises, articulation practice, language-building activities, and communication techniques. The approach is interactive, child-friendly, and designed to improve clarity and confidence over time." },
                  { question: "How long does speech therapy take to show results?", answer: "Duration varies by age, condition, and severity. Some people see improvement in a few weeks, while others need months of consistent therapy. Regular attendance and home practice significantly speed up progress. The therapist usually reviews progress every few sessions to adjust the treatment plan." },
                  {question: "Is speech therapy effective for adults?", answer: "Yes, adults benefit greatly from speech therapy. It helps with stammering, unclear speech, voice disorders, communication issues, and speech difficulties after a stroke or injury. Therapy focuses on improving fluency, confidence, vocal quality, and communication skills for personal and professional life."},
                  {question: "Do parents need to participate in their child's therapy?", answer: "Parent involvement is important for faster results. Therapists guide parents on simple home exercises and communication activities to practise daily. Reinforcing techniques at home helps children improve more consistently and makes the therapy more effective in the long term."}
                ].map((item, index) => (
                  <div className={`pq-accordion-box ${activeIndex === index ? 'active' : ''}`} key={index}>
                    <div className="pq-ad-title" onClick={() => toggleAccordion(index)}>
                      <h4 className="ad-title-text">
                        {item.question}
                        <i className={`fa ${activeIndex === index ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                      </h4>
                    </div>
                    <div className={`pq-accordion-details ${activeIndex === index ? 'open' : ''}`}>
                      <p className="pq-detail-text">{item.answer}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
             </div>
            <div className="col-md-5 m-auto">
                  <div className="card shadow-lg">
                     <iframe width="100%" height="315" src="https://www.youtube.com/embed/GNEgbD7SAX8?si=IHtPxmfNUkYXI31L" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                  <div class="p-3"><h5 class="text-success mb-0">Speech Therapy, Swallow Therapy, Myofunctional Therapy, TMJ Therapy, Med First ENT Centre</h5></div>
          </div>
              </div>
          </div>
        </div>
      </section>
    </div>
  );
}
